import "./App.css";
import NavBar from "./component/NavBar";
import BodyContent from "./component/BodyContent";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  // useLocation,
} from "react-router-dom";
import Terms from "./component/Terms";
import Policy from "./component/Policy";
import ThankYouScreen from "./component/ThankYouScreen";
import Lodha from "./projects/Lodha";
import Godrej from "./projects/Godrej";
import LnT from "./projects/LnT";
import Chatbot from "./component/Chatbot";
import Prestige from "./projects/Prestige";
import Shapoorji from "./projects/SP";
import BlogDetails from "./component/Blog/BlogDetails";

const App = () => {
  return (
    <Router>
      <MainApp />
    </Router>
  );
};

const MainApp = () => {
  // const location = useLocation();

  return (
    <>
      <NavBar />
      <Routes>
        <Route path="/" element={<BodyContent />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/policy" element={<Policy />} />
        <Route path="/thank-you" element={<ThankYouScreen />} />
        <Route path="/lodha" element={<Lodha />} />
        <Route path="/godrej" element={<Godrej />} />
        <Route path="/LnT" element={<LnT />} />
        <Route path="/prestige" element={<Prestige />} />
        <Route path="/sp" element={<Shapoorji />} />
        <Route path="/blog/:id" element={<BlogDetails/>} />
      </Routes>
      {/* {location.pathname !== "/thank-you" && <Footer />} */}
      <Chatbot />
    </>
  );
};
export default App;
